import {
    connect,
    injectReducer,
    injectSaga,
} from '@vfde-fe/sails_core';
import { NAMESPACE } from './constants';

import { createStructuredSelector } from 'reselect';
import disconnectWebchatReducer from './reducer';
import disconnectWebchatSaga from './sagas';

import { RootState } from './types';

function disconnectWebchat (_state, _actions) {

    injectReducer(NAMESPACE, disconnectWebchatReducer);
    injectSaga(NAMESPACE, disconnectWebchatSaga);

    return {
        /**
         * This function is called on first load and everytime the store changes.
         * @param newState
         * @param oldState
         */
        getDerivedStateFromProps (newState, oldState) {
            // do nothing because it is fire and forget
        },
    };
}

/**
 * mapStateToProps = We are mapping the given states to props mapDispatch
 */
const mapStateToProps = createStructuredSelector<RootState, {}>({

});

/**
 * mapDispatch = We are mapping the given action dispatch function to props Result.
 * You can use the states and dispatches as a prop in the main function
 */
const mapDispatch = {};

const DisconnectWebchat = connect(mapStateToProps, mapDispatch)(disconnectWebchat);

export default DisconnectWebchat;
